export default {
  primary: '#305A3D',
  secondary: '#DAA900',
  text: '#555555',
  background: '#F2F0EC',
  primaryHover: '#447152',
}
